{
  "familyId": "STU-NOTITIES",
  "questions": [
    {
      "id": "STU-NOTITIES-001",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "multiple_choice",
      "question": "Wat is het belangrijkste doel van notities maken tijdens een les?",
      "options": ["De belangrijkste informatie onthouden", "Alles letterlijk opschrijven", "Mooie zinnen maken", "De leraar laten zien dat je oplet"],
      "correctAnswer": 0,
      "context": "Doel van notities",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.notities-letterlijk-overschrijven", "label": "Wil alles letterlijk opschrijven", "optionIndex": 1 },
          { "id": "stu.notities-esthetiek-boven-functie", "label": "Verwart functie met esthetiek", "optionIndex": 2 },
          { "id": "stu.notities-als-sociaal-signaal", "label": "Notities als sociaal signaal", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Doel van notities",
            "content": "Notities helpen je de belangrijkste informatie te onthouden. Je schrijft niet alles op, maar alleen de kernpunten.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "notities_doel",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "Notities zijn een geheugensteun: door kernpunten op te schrijven, verwerk je de stof beter en kun je later terugkijken.",
        "solutionSteps": [
          "Notities = hulpmiddel om te onthouden",
          "Schrijf kernpunten op, niet alles",
          "Gebruik later om te leren"
        ],
        "distractorExplanations": {
          "0": "Goed! Notities helpen je informatie onthouden.",
          "1": "Alles opschrijven betekent dat je niet meer luistert — schrijf alleen kernpunten.",
          "2": "Notities zijn voor jezelf — duidelijk is belangrijker dan mooi.",
          "3": "Opletten is belangrijk, maar dat is geen DOEL van notities maken."
        }
      }
    },
    {
      "id": "STU-NOTITIES-002",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "multiple_choice",
      "question": "Welke techniek is het handigst bij het maken van notities?",
      "options": ["Steekwoorden en afkortingen gebruiken", "Hele zinnen opschrijven", "Alleen de titel opschrijven", "Alles in één lange zin schrijven"],
      "correctAnswer": 0,
      "context": "Snel-schrijftechniek",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.notities-hele-zinnen", "label": "Wil hele zinnen schrijven", "optionIndex": 1 },
          { "id": "stu.notities-alleen-titels", "label": "Denkt dat titel volstaat", "optionIndex": 2 },
          { "id": "stu.notities-een-lange-zin", "label": "Schrijft in één lange zin", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Notitietechniek",
            "content": "Gebruik steekwoorden en afkortingen. Voorbeeld: 'fotosynthese = plant maakt voedsel m.b.v. zonlicht'.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "notities_techniek",
      "variantIndex": 2,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Steekwoorden + afkortingen = snel én effectief. Zo houd je tijd over om te luisteren én te denken.",
        "solutionSteps": [
          "Gebruik steekwoorden (kernwoorden)",
          "Gebruik afkortingen (bv. voor 'bijvoorbeeld')",
          "Schrijf snel, luister goed"
        ],
        "distractorExplanations": {
          "0": "Goed! Steekwoorden zijn snel en effectief.",
          "1": "Hele zinnen kosten te veel tijd — je luistert dan niet meer.",
          "2": "Alleen de titel zegt niets over wat er besproken is.",
          "3": "Eén lange zin is moeilijk terug te lezen — gebruik korte punten."
        }
      }
    },
    {
      "id": "STU-NOTITIES-003",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "text_highlight",
      "question": "De juf vertelt in de les: lees de tekst en tik op de kernwoorden die je zou opschrijven als notitie.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "Een vulkaan is een opening in de aardkorst. Hierdoor komt magma naar buiten. Magma heet boven de grond lava. Vulkanen kunnen erg gevaarlijk zijn voor mensen die in de buurt wonen.",
        "correctHighlights": [
          { "start": 4, "end": 11 },
          { "start": 58, "end": 63 },
          { "start": 103, "end": 107 }
        ]
      },
      "context": "Kernwoorden selecteren uit een uitleg",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "readingPassage",
          "showWhen": "always",
          "data": {
            "passage": "Een vulkaan is een opening in de aardkorst. Hierdoor komt magma naar buiten. Magma heet boven de grond lava. Vulkanen kunnen erg gevaarlijk zijn voor mensen die in de buurt wonen.",
            "instruction": "Lees wat de juf vertelt"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kernwoorden kiezen",
            "content": "Kernwoorden zijn de begrippen die de uitleg uitleggen. Hier: vulkaan, magma, lava. 'Aardkorst' en 'gevaarlijk' zijn details — die kun je weglaten of in steekwoorden bij de kernbegrippen schrijven.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "notities_kernwoord_select",
      "variantIndex": 3,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De kernwoorden zijn 'vulkaan', 'magma' en 'lava' — dit zijn de drie nieuwe begrippen die de juf uitlegt. In je notitie schrijf je: 'vulkaan = opening aardkorst → magma → lava (boven grond)'.",
        "solutionSteps": [
          "Wat zijn de NIEUWE begrippen? → vulkaan, magma, lava",
          "Wat is de UITLEG? → details bij de begrippen",
          "Notitievorm: vulkaan = opening → magma → lava"
        ]
      }
    },
    {
      "id": "STU-NOTITIES-004",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "multiple_choice",
      "question": "Wanneer is het handig om je notities na te kijken en aan te vullen?",
      "options": ["Zo snel mogelijk na de les", "Pas vlak voor de toets", "Nooit, notities zijn af als je ze maakt", "Alleen als de leraar het vraagt"],
      "correctAnswer": 0,
      "context": "Nakijken — vergeetcurve van Ebbinghaus",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "stu.notities-pas-voor-toets", "label": "Wacht tot vlak voor toets", "optionIndex": 1 },
          { "id": "stu.notities-nooit-teruglezen", "label": "Kijkt nooit opnieuw", "optionIndex": 2 },
          { "id": "stu.notities-alleen-op-verzoek", "label": "Hangt af van leraar", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vergeetcurve",
            "content": "Na 1 dag ben je al 50% vergeten. Door snel na de les je notities aan te vullen, herinner je veel meer.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "notities_nakijken",
      "variantIndex": 4,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Hoe sneller je nakijkt, hoe minder je vergeet. De vergeetcurve (Ebbinghaus) laat zien dat we na 1 dag al 50% vergeten — dus liefst direct na de les.",
        "solutionSteps": [
          "Direct na de les: notities nakijken",
          "Onduidelijke punten aanvullen",
          "Vóór 24 uur = onthoud je veel meer"
        ],
        "distractorExplanations": {
          "0": "Goed! Zo snel mogelijk = beste resultaat.",
          "1": "Vlak voor de toets ben je al veel vergeten — dan zijn je notities onduidelijk.",
          "2": "Tijdens de les schrijf je snel — nakijken maakt je notities compleet.",
          "3": "Notities zijn voor jezelf — jij hebt er het meeste aan."
        }
      }
    },
    {
      "id": "STU-NOTITIES-005",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "matching",
      "question": "Koppel elke notitietechniek aan de juiste beschrijving.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "Steekwoorden", "right": "Kernwoorden uit de les" },
          { "left": "Afkortingen", "right": "Maken schrijven sneller" },
          { "left": "Pijltjes (→)", "right": "Geven verbanden aan" },
          { "left": "Opsommingstekens (•)", "right": "Maken een lijst overzichtelijk" }
        ]
      },
      "context": "Notitietechnieken",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Notitietechnieken",
            "content": "Steekwoorden = kernwoorden. Afkortingen = sneller. Pijltjes = verbanden. Opsommingstekens = overzicht.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "notities_technieken_koppelen",
      "variantIndex": 5,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Steekwoorden → kernwoorden. Afkortingen → schrijfsnelheid. Pijltjes → verbanden (oorzaak → gevolg). Opsommingstekens → lijststructuur.",
        "solutionSteps": [
          "Steekwoorden → kernwoorden uit de les",
          "Afkortingen → maken schrijven sneller",
          "Pijltjes (→) → geven verbanden aan",
          "Opsommingstekens (•) → maken een lijst overzichtelijk"
        ]
      }
    },
    {
      "id": "STU-NOTITIES-006",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "categorize",
      "question": "Sleep elk voorbeeld naar de juiste categorie: is het een goede notitie of moet die korter?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Goede notitie", "Te lang of niet bruikbaar"],
        "items": [
          { "text": "fotosynthese = plant maakt voedsel m.b.v. zonlicht", "correctCategory": 0 },
          { "text": "Mijn juf zei vandaag dat de plant heel mooi groen is en dat ik dat heel interessant vond", "correctCategory": 1 },
          { "text": "Drie soorten wolken: stapel, sluier, regen", "correctCategory": 0 },
          { "text": "Bladeren", "correctCategory": 1 },
          { "text": "WO II: 1939-1945, oorzaak = inval Polen door Duitsland", "correctCategory": 0 },
          { "text": "De leraar staat voor het bord en vertelt iets", "correctCategory": 1 }
        ]
      },
      "context": "Goede vs slechte notities herkennen",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Wanneer is een notitie goed?",
            "content": "Goed = kernwoord(en) + korte uitleg + (eventueel) symbool. Slecht = te vaag, te kort (alleen woord) of te lang (hele zinnen + mening).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "notities_kwaliteit_judge",
      "variantIndex": 6,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Goede notities hebben kernwoorden + korte uitleg + symbolen (=, →). Te lang = hele zinnen met details/meningen. Te kort = alleen één woord zonder context.",
        "solutionSteps": [
          "'fotosynthese = plant maakt voedsel m.b.v. zonlicht' → kort + uitleg ✓",
          "'Mijn juf zei...interessant' → mening + irrelevante details ✗",
          "'Drie soorten wolken: stapel, sluier, regen' → opsomming met categorie ✓",
          "'Bladeren' → te kort, geen context ✗",
          "'WO II: 1939-1945, oorzaak = inval Polen' → datum + verband ✓",
          "'De leraar staat...iets' → niets onthouden, geen kernwoord ✗"
        ]
      }
    },
    {
      "id": "STU-NOTITIES-007",
      "familyId": "STU-NOTITIES",
      "module": "Studievaardig",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "leerstrategieen",
      "subSkill": "leer_notities",
      "questionType": "ordering",
      "question": "Zet de stappen voor effectief notities maken in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Luister actief naar wat de leraar zegt",
          "Schrijf kernwoorden + steekwoorden op",
          "Gebruik pijltjes en symbolen voor verbanden",
          "Kijk je notities zo snel mogelijk na de les na"
        ],
        "correctOrder": [0, 1, 2, 3]
      },
      "context": "Workflow effectieve notities",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Notitie-workflow",
            "content": "Eerst luisteren, dan kernwoorden noteren, dan symbolen voor structuur, en na de les nakijken om aan te vullen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "notities_workflow",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Eerst luisteren → dan pas schrijven (anders mis je info). Symbolen toevoegen voor verbanden. Direct na de les nakijken zorgt dat je notities compleet blijven.",
        "solutionSteps": [
          "1. Luister actief (eerst snappen)",
          "2. Noteer kernwoorden + steekwoorden",
          "3. Voeg symbolen toe voor verbanden",
          "4. Kijk direct na de les na en vul aan"
        ]
      }
    }
  ]
}